import {Tabs} from '@chakra-ui/react'
import {useTranslate} from '@tolgee/react'

export function DoseReductionTabsList() {
  const {t} = useTranslate('dose-reduction')
  return (
    <Tabs.List width={'100%'}>
      <Tabs.Trigger width="100%" value="global">
        {t('global')}
      </Tabs.Trigger>
      <Tabs.Trigger width="100%" value="individual">
        {t('individual')}
      </Tabs.Trigger>
    </Tabs.List>
  )
}
